import { Trash2 } from "lucide-react";
import React, { useState } from "react";
import Select from "react-select";

const MOCK_USERS = [
    { id: 1, name: "John Doe", avatar: "/avatars/1.png" },
    { id: 2, name: "Sarah Lee", avatar: "/avatars/2.png" },
    { id: 3, name: "Michael Tan", avatar: "/avatars/3.png" },
    { id: 4, name: "Emma Patel", avatar: "/avatars/4.png" },
];

const Assigne = ({ isOpen, onClose, onApply }) => {
    const [selectedUsers, setSelectedUsers] = useState([]);

    if (!isOpen) return null;

    const userOptions = MOCK_USERS.map(user => ({
        value: user.id,
        label: user.name,
        avatar: user.avatar,
    }));

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
            <div
                onClick={(e) => e.stopPropagation()}
                className="bg-white rounded-lg shadow-xl p-3 w-80 max-w-full"
            >
                <h2 className="text-lg font-semibold tracking-wide mb-3">Assignee</h2>

                {/* Multi Select */}
                <Select
                    options={userOptions}
                    isMulti
                    value={selectedUsers}
                    onChange={setSelectedUsers}
                    placeholder="Select assignee(s)"
                    className="text-sm cursor-pointer"
                    classNamePrefix="rs"
                    formatOptionLabel={(option) => (
                        <div className="flex items-center gap-2">
                            <img
                                src={option.avatar}
                                className="w-6 h-6 rounded-full"
                                alt={option.label}
                            />
                            <span>{option.label}</span>
                        </div>
                    )}
                />

                {/* Selected Avatars */}
                {selectedUsers.length > 0 && (
                    <div className="mt-4 flex flex-wrap gap-2">
                        {selectedUsers.map((user) => (
                            <div
                                key={user.value}
                                className="relative cursor-pointer group"
                                onClick={() =>
                                    setSelectedUsers(prev =>
                                        prev.filter(u => u.value !== user.value)
                                    )
                                }
                            >
                                <img
                                    src={user.avatar}
                                    className="w-10 h-10 rounded-full border"
                                    alt={user.label}
                                />
                                <div className="absolute inset-0 bg-black/50 rounded-full hidden group-hover:flex items-center justify-center text-white text-xs">
                                    <Trash2 size={14} />
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {/* Buttons */}
                <div className="flex justify-end gap-3 mt-6">
                    <button
                        onClick={onClose}
                        className="px-3 py-1 bg-gray-200 rounded-lg hover:bg-gray-300 transition"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={() => {
                            onApply(selectedUsers);
                            onClose();
                        }}
                        className="px-3 py-1 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
                    >
                        Apply
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Assigne;
